'use strict';

function isDefined(o) {
  return o !== undefined;
}

module.exports = isDefined;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isDefined.js
// module id = 27
// module chunks = 1